module.exports = __webpack_public_path__ + "img/henkilot.96bae709.jpg";